import type { RadioGroupFieldTypeConstraint } from '@bos/form';
import type { FieldPathByValue, FieldValues } from 'react-hook-form';

import type { ReplaceTestIdWithAppOne } from '../../../const/testIds';

import type { AppBaseRadioGroupFieldProps } from './AppBaseRadioGroupField';
import { AppBaseRadioGroupField } from './AppBaseRadioGroupField';

export type AppRadioGroupFieldProps<
	TFieldValues extends FieldValues,
	TFieldName extends FieldPathByValue<
		TFieldValues,
		RadioGroupFieldTypeConstraint
	>,
> = ReplaceTestIdWithAppOne<
	AppBaseRadioGroupFieldProps<TFieldValues, TFieldName>
>;

export const AppRadioGroupField = <
	TFieldValues extends FieldValues,
	TFieldName extends FieldPathByValue<
		TFieldValues,
		RadioGroupFieldTypeConstraint
	>,
>(
	props: AppRadioGroupFieldProps<TFieldValues, TFieldName>,
) => <AppBaseRadioGroupField {...props} />;
